module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('c-view', [_c('c-page', [_c('c-content', [_c('div', {
    staticClass: "protocol-container"
  }, [_c('div', {
    staticClass: "protocol-title text-center"
  }, [_vm._v("自动续费服务规则")]), _vm._v(" "), _c('div', {
    staticClass: "protocol-text"
  }, [_c('div', [_vm._v("\n            本规则被视为《生意专家隐私政策》的补充协议，是其不可分割的组成部分，与其具有同等法律效力。如本规则与《生意专家隐私政策》存在冲突的，以本规则为准。请您在点击“立即开通”使用生意专家高级版自动续费服务前，仔细阅读本规则条款。当您开通生意专家高级版自动续费服务时视为您已充分理解并同意如下使用规则：\n          ")]), _vm._v(" "), _c('div', [_vm._v("\n            1．本服务是在您已开通生意专家高级版服务的前提下，为您提供的自动续费服务。如您开通本服务，则视为您授权生意专家有权在您的生意专家高级版服务即将到期时，从您的iTunes账户（以下统称“账户”）余额中代扣下ー个服务周期的服务费，服务周期包括但不限于1个月、1年等（具体以您实际选择开通的服务周期为准）。在开通本服务后，请确保您已将所开通的生意专家账号与上述账户绑定，且账户余额不少于服务费用。若因您未绑定账户或所绑定的账户中可扣款余额不足而导致的续费失败，由您自行承担。\n          ")]), _vm._v(" "), _c('div', [_vm._v("\n            2．开通自动续费服务的账号，会在每个服务周期到期前24小时，自动在iTunes账户扣费并按对应的期限延长您的会员有效期。如需取消订阅，请手动打开苹果手机“设置”ー－＞进入“iTunes Store与 App Store”－－＞点击“ Apple ID”，选择＂查看 Apple ID＂，进入＂账户设置＂页面，点击“订阅”，选择生意专家高级版连续包年服务取消订阅即可。如未在订阅期结束的至少24小时前关闭订阅的，将视为您同意继续授权，此订阅将会自动续订。\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "protocol-footer"
  }, [_c('div', {
    staticClass: "text-right"
  }, [_vm._v("\n            上海圆贝信息科技有限公司\n          ")])])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0403b3b5","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/about-me/apple-auto-renew-protocol/index.vue
// module id = 1013
// module chunks = 2